module.exports = __webpack_public_path__ + "static/media/flug.fb40a49a.jpg";